'use strict';

const mmWidgets = require('../widgets/mm-widgets'),
	config = require('@mindmup/config'),
	NavigatorShim  = require('../widgets/navigator-shim'),
	AssetUploadController = require('../models/asset-upload-controller'),
	GoldAWSApi = require('../models/gold-aws-api'),
	ActivityLog = require('../models/activity-log'),
	S3Api = require('../models/s3-api'),
	S3FileModel = require('../models/s3-file-model'),
	AjaxPromise = require('../models/ajax-promise'),
	GoldFilePicker = require('../models/gold-file-picker'),
	GoldImagePicker = require('../models/gold-image-picker'),
	GoldResourceManager = require('../models/gold-resource-manager'),
	GoldAttachmentPicker = require('../models/gold-attachment-picker'),
	IconEditorController = require('../models/icon-editor-controller'),
	domImageDimensionCalculator = require('../widgets/dom-image-dimension-calculator'),
	GoldDrivePageState = require('../models/gold-drive-page-state'),
	WriterModel = require('../models/writer-model'),
	AttachmentEditorController = require('../models/attachment-editor-controller'),
	initialRenameMediator = require('../models/initial-rename-mediator'),
	GoldDrivePageController = require('../models/gold-drive-page-controller'),
	NetworkStatusDispatcher = require('../models/network-status-dispatcher'),
	IconLocaliser = require('../models/icon-localiser'),
	StoryboardModel = require('../models/storyboard-model'),
	StoryboardDimensionProvider = require('../models/storyboard-dimension-provider'),
	StoryboardController = require('../models/storyboard-controller'),
	StoryboardMapMediator = require('../models/storyboard-map-mediator'),
	storyboardFontSize = require('../widgets/storyboard-font-size'),
	GoldFunnelModel = require('../models/gold-funnel-model'),
	FileChangesModel = require('../models/file-changes-model'),
	UnsavedChangesModel = require('../models/unsaved-changes-model'),
	GoldFileChangesCache = require('../models/gold-file-changes-cache'),
	GoldFileChangesModel = require('../models/gold-file-changes-model'),
	GoldFileHistoryEnvelopeSorter = require('@mindmup/mindmup-common/src/gold-file-history-envelope-sorter'),
	CopyFileController = require('../models/copy-file-controller'),
	LinkedSubmapController = require('../models/linked-submap-controller'),
	cognitoStart = require('../features/cognito/cognito-start'),
	authenticationAWSStart = require('../features/authentication/authentication-aws-start'),
	defaultMapContent = require('../models/default-map-content'),
	GoldIconPacker = require('../models/gold-icon-packer'),
	GoldAttachmentPacker = require('../models/gold-attachment-packer'),
	GoldIconUnpacker = require('../models/gold-icon-unpacker'),
	GoldAttachmentUnpacker = require('../models/gold-attachment-unpacker'),
	GoldAttachmentLocaliser = require('../models/gold-attachment-localiser'),
	IntentProcessor  = require('../models/intent-processor'),
	AssetLocaliser = require('../models/asset-localiser'),
	CorsProxyFallbackDownloader = require('../models/cors-proxy-fallback-downloader'),
	progressStart = require('../features/progress/progress-start'),
	SubscriptionPlanModel = require('../models/subscription-plan-model'),
	ThumbnailBuilder = require('../widgets/thumbnail-builder'),
	personalSignupStart = require('../features/signup/personal-signup-start'),
	ConfigurationGenerator = require('../models/configuration-generator'),
	ContextMenuModel = require('../models/context-menu-model'),
	mapEditingStart = require('../features/map-editing/map-editing-start'),
	mapViewingStart = require('../features/map-viewing/map-viewing-start'),
	mapExportsStart = require('../features/map-exports/map-exports-start'),
	measuresStart = require('../features/measures/measures-start'),
	pageActionsStart = require('../features/page-actions-start'),
	formatNoteToHtml = require('@mindmup/mapjs').formatNoteToHtml,
	MapSharingModel = require('../models/map-sharing-model'),
	MapContentExporter = require('../models/map-content-exporter'),
	fileImportStart = require('../features/file-import/file-import-aws-start'),
	GoldFileChangesEnvelopeBuilder = require('@mindmup/mindmup-common/src/gold-file-changes-envelope-builder'),
	clipboardStart = require('../features/clipboard-start'),
	SubteamApi = require('../models/sub-team-api'),
	CollaborationModel = require('../models/collaboration-model'),
	GoldMapCreatorModel = require('../models/gold-map-creator-model'),
	plans = require('../models/plans'),
	GoldFileListModel = require('../models/gold-file-list-model'),
	GoldFileListPreferences = require('../models/gold-file-list-preferences'),
	historyViewStart = require('../features/history-view-start'),
	ConfirmationSender = require('../models/confirmation-sender'),
	goldSessionsStart = require('../features/gold-sessions-start'),
	uniqueString = require('@mindmup/js-utils/src/unique-string');


require('../widgets/contact-link-widget');

require('../widgets/tabbed-section-widget');
require('../widgets/subscription-profile-widget');
require('../widgets/add-measure-widget');
require('../widgets/attachment-editor-widget');
require('../widgets/blob-downloader-link-widget');
require('../widgets/context-disabler-widget');
require('../widgets/download-link-widget');
require('../widgets/context-menu-widget');
require('../widgets/file-name-widget');
require('../widgets/gold-drive-import-widget');
require('../widgets/storyboard-key-handler-widget');
require('../widgets/storyboard-widget');
require('../widgets/icon-editor-widget');

require('../widgets/node-context-widget');
require('../widgets/sidebar-widget');
require('../widgets/search-widget');
require('../widgets/selectable-readonly-input-widget');
require('../widgets/keyboard-color-widget');

/* only on editor pages */
require('../widgets/page-scroll-key-override');
require('../widgets/macify-hotkeys-widget');
require('../widgets/popup-link-widget');
require('../widgets/full-screen-view-widget');
require('../widgets/show-hotkey-widget');
require('../widgets/install-hotkey-widget');
require('../widgets/menu-bar-widget');

require('../widgets/move-to-folder-widget');
require('../widgets/writer-widget');
require('../widgets/copy-file-widget');
require('../widgets/splittable-widget');
require('../widgets/gold-map-sharing-widget');
require('../widgets/file-info-value-toggle-widget');
require('../widgets/file-timestamp-widget');
require('../widgets/anonymous-files-widget');
require('../widgets/file-tags-widget');



module.exports = function editorAWS() {
	const navigatorShim = new NavigatorShim(),
		goldPageState = new GoldDrivePageState(config, navigatorShim),
		activityLog = new ActivityLog(1000),
		storage = navigatorShim.getJsonStorage(),
		subscriptionPlanModel = new SubscriptionPlanModel(plans(config.allowedAccountTypes)),
		ajaxPromise = new AjaxPromise(navigatorShim),
		goldApi = new GoldAWSApi(ajaxPromise, config.goldAWSApiUrl),
		authentication = authenticationAWSStart(config, goldApi, navigatorShim, window, ajaxPromise),
		configurationGenerator = new ConfigurationGenerator(goldApi, authentication.authenticationModel),
		s3Api = new S3Api(navigatorShim, ajaxPromise),
		filePicker = new GoldFilePicker(navigatorShim),
		clientSecret = uniqueString(),
		s3FileModel = new S3FileModel(config, authentication, goldApi, s3Api, navigatorShim, defaultMapContent, {useWatermark: true, clientSecret}),
		collaborationModel = new CollaborationModel(),
		goldResourceManager = new GoldResourceManager(s3FileModel, domImageDimensionCalculator, goldPageState, collaborationModel),
		mapViewing = mapViewingStart(config, activityLog, navigatorShim, collaborationModel, goldResourceManager.getResource),
		imagePicker = new GoldImagePicker(filePicker, goldPageState, goldResourceManager),
		attachmentPicker = new GoldAttachmentPicker(filePicker, goldPageState, goldResourceManager, {subscriptionModel: authentication.subscriptionModel}),
		goldAttachmentLocaliser = new GoldAttachmentLocaliser(navigatorShim, goldResourceManager),
		version = navigatorShim.getMMVersion(),
		mapEditing = mapEditingStart(Object.assign({config, ajaxPromise, storage, version, imagePicker}, mapViewing)),
		progress = progressStart(mapViewing.mapModel, imagePicker, goldResourceManager.calculateImageDimensions, mapEditing.colorPickerModel, false, goldResourceManager.getResource),
		iconEditorController = new IconEditorController(mapViewing.mapModel, imagePicker, goldResourceManager.calculateImageDimensions),
		container = document.querySelector('mapeditor'),
		writerModel = new WriterModel(mapViewing.collaborationModel, mapViewing.mapModel, 'note'),
		attachmentEditorController = new AttachmentEditorController(mapViewing.mapModel, attachmentPicker, navigatorShim, writerModel, {resourceManager: goldResourceManager}),
		corsProxyFallbackDownloader = new CorsProxyFallbackDownloader(config, navigatorShim, ajaxPromise, '/assets/image-placeholder.svg'),
		iconLocaliser = new IconLocaliser(corsProxyFallbackDownloader, goldResourceManager),
		assetLocaliser = new AssetLocaliser([goldAttachmentLocaliser.localiseSingleAttachment, iconLocaliser.localiseSingleIcon], {resourceManager: goldResourceManager, localiseBackgroundImage: iconLocaliser.localiseBackgroundImage}),
		thumbnailContentExporter = new MapContentExporter(assetLocaliser, mapViewing.collaborationModel, mapViewing.mapModel, mapViewing.themeProvider, mapViewing.nodeViewModel, {localiserOptions: {imageScale: 1}, literalTheme: true}).makeExportable,
		thumbnailBuilder = new ThumbnailBuilder(config, thumbnailContentExporter, navigatorShim, corsProxyFallbackDownloader, mapViewing.themeProvider, mapViewing.mapModel),
		networkStatusDispatcher = new NetworkStatusDispatcher(config, navigatorShim),
		goldFileChangesCache = new GoldFileChangesCache(),
		envelopeBuilder = new GoldFileChangesEnvelopeBuilder(authentication.authenticationModel, mapViewing.collaborationModel.getLocalSessionId),
		goldSessions = goldSessionsStart({config, navigatorShim, authenticationModel: authentication.authenticationModel, goldApi, mapModel: mapViewing.mapModel}),
		goldFileChangesModel = new GoldFileChangesModel({collaborationModel: mapViewing.collaborationModel, s3FileModel, pageState: goldPageState, navigatorShim, networkStatusDispatcher, resourceManager: goldResourceManager, goldFileChangesCache, envelopeBuilder, goldFileHistoryEnvelopeSorter: new GoldFileHistoryEnvelopeSorter()}, { thumbnailBuilder, disableReupload: true, goldSessionModel: goldSessions.goldSessionModel, webSocketShim: goldSessions.webSocketShim}),
		unsavedChangesModel = new UnsavedChangesModel(navigatorShim, mapViewing.collaborationModel, storage, authentication.subscriptionModel, true),
		goldPageController = new GoldDrivePageController({config, navigatorShim, subscriptionModel: authentication.subscriptionModel, collaborationModel: mapViewing.collaborationModel, pageState: goldPageState, s3FileModel, resourceManager: goldResourceManager, goldFileChangesModel, jsonStorage: storage, unsavedChangesModel}, {thumbnailBuilder}),
		subteamApi = new SubteamApi(authentication, goldApi, s3Api),
		mapSharingModel = new MapSharingModel(goldPageController, s3FileModel, subteamApi),
		fileImport = fileImportStart(config, filePicker, authentication.subscriptionModel, navigatorShim, s3FileModel, configurationGenerator, s3Api, goldApi),
		measures = measuresStart(config, mapViewing.collaborationModel, mapViewing.mapModel, navigatorShim),
		storyboardModel = new StoryboardModel(mapViewing.collaborationModel, 'storyboards', 'storyboard-scenes'),
		storyboardDimensionProvider = new StoryboardDimensionProvider(storyboardFontSize, goldResourceManager),
		storyboardController = new StoryboardController(storyboardModel, mapViewing.mapModel),
		storyboardMapMediator = new StoryboardMapMediator(mapViewing.mapModel, storyboardController),
		goldFunnelModel = new GoldFunnelModel(activityLog),
		mapExports = mapExportsStart(config, configurationGenerator, s3Api, activityLog, goldFunnelModel, navigatorShim, mapViewing.collaborationModel, mapViewing.mapModel, mapViewing.themeProvider, iconLocaliser,  assetLocaliser, storyboardModel, storyboardDimensionProvider, ajaxPromise, authentication, goldApi, goldPageController, mapViewing.nodeViewModel, goldFileChangesModel),
		fileChangesModel = new FileChangesModel(goldPageController, mapViewing.collaborationModel, unsavedChangesModel, goldFileChangesModel),
		copyFileController = new CopyFileController(config, s3FileModel, mapExports.localMapContentExporter.makeExportable, goldPageController),
		linkedSubmapController = new LinkedSubmapController(config, s3FileModel, mapExports.localMapContentExporter.makeExportable, mapEditing.mapEditorModel, navigatorShim),
		cognito = cognitoStart(config, goldApi, authentication.subscriptionModel, authentication.authenticationModel, authentication.reauthenticator, navigatorShim),
		assetUploadController = new AssetUploadController(goldResourceManager, {skipConfirmation: true}),
		goldFileListPreferences = new GoldFileListPreferences(),
		goldFileListModel = new GoldFileListModel(goldFileListPreferences, s3FileModel, config.editorUrl, navigatorShim, {pageState: goldPageState}),
		clipboard = clipboardStart(mapViewing.mapModel, mapViewing.mapThemeModel, {
			packers: [
				new GoldIconPacker(goldResourceManager, goldPageState),
				new GoldAttachmentPacker(goldResourceManager, goldPageState)
			],
			unpackers: [
				new GoldIconUnpacker(corsProxyFallbackDownloader, {pageState: goldPageState}),
				new GoldAttachmentUnpacker(navigatorShim, goldPageState),
				assetUploadController
			],
			goldFileChangesModel
		}, navigatorShim),
		contextMenuModel = new ContextMenuModel(mapViewing.mapModel),
		mapCreatorModel = new GoldMapCreatorModel(config, navigatorShim),
		historyView = historyViewStart(collaborationModel, navigatorShim, goldPageController),
		confirmationSender = new ConfirmationSender({storage, goldApi, authenticationModel: authentication.authenticationModel, source: navigatorShim.getHostName()}),
		editingContext = navigatorShim.getHashStringValue('editingContext'),
		components = Object.assign({
			assetUploadController,
			attachmentEditorController,
			fileChangesModel,
			cognito,
			confirmationSender,
			contextMenuModel,
			copyFileController,
			goldPageState,
			goldFileChangesModel,
			goldFileListModel,
			goldFunnelModel,
			iconEditorController,
			mapCreatorModel,
			mapSharingModel,
			navigatorModel: navigatorShim,
			networkStatusDispatcher,
			pageController: goldPageController,
			s3FileModel,
			storyboardMapMediator,
			storyboardModel,
			storyboardController,
			subteamApi: subteamApi,
			unsavedChangesModel,
			linkedSubmapController,
			writerModel
		}, goldSessions, authentication, mapEditing, mapViewing, mapExports, progress, historyView, clipboard, fileImport, measures);
	mapViewing.collaborationModel.addEventListener('newSession', () => confirmationSender.confirm('map-loaded'));
	personalSignupStart(config, authentication.subscriptionModel, subscriptionPlanModel, authentication.authenticationModel, navigatorShim, s3Api, goldApi);
	new IntentProcessor(navigatorShim, goldPageController, copyFileController);
	pageActionsStart(components, container);
	window.components = components;

	authentication.subscriptionModel.addEventListener('goldAccountInfo', accountInfo => {
		if (accountInfo && accountInfo.subscription) {
			goldFileListModel.setAllowedActions(accountInfo.subscription.actions);
		}
	});

	authentication.authenticationModel.addEventListener('authenticatedProfile not-authenticated', (reason) => {
		if (reason === 'signed-out') {
			navigatorShim.redirect('/');
			return;
		}
	});
	goldPageController.addEventListener('ready', () => {
		const idea = mapViewing.collaborationModel.getActiveContent();
		mapViewing.mapModel.setIdea(idea);
		progress.progressModel.bindContentListeners();
		mapViewing.mapModel.focusAndSelect(idea.getDefaultRootId());
	});
	initialRenameMediator(config, mapViewing.collaborationModel, goldPageController);

	//widgets
	mmWidgets('[data-mm-hotkey]').macifyHotkeys(navigatorShim);
	mmWidgets('[data-mm-subscription-profile]').subscriptionProfileWidget(authentication.subscriptionModel);
	mmWidgets('[data-mm-role="copyFileWidget"]').copyFileWidget(copyFileController, goldPageController);

	mmWidgets('body').splittableWidget(mapEditing.splittableModel, mapViewing.mapModel, true);
	if (navigatorShim.isMobile()  && navigatorShim.isTouch()) {
		mmWidgets('body').addClass('touchdevice');
	}
	mmWidgets('[data-mm-role="iconEditorWidget"]').iconEditorWidget(iconEditorController, goldResourceManager.getResource);
	mmWidgets('[data-mm-role="file-name"]').fileNameWidget(goldPageController, goldFileChangesModel);

	mmWidgets('[data-mm-role="attachmentEditorWidget"]').attachmentEditorWidget(attachmentEditorController);
	mmWidgets('[data-mm-role="contactLink"]').contactLinkWidget(config, navigatorShim);


	components.domMapController = mapViewing.initialiseWidgets(container, goldSessions, mapEditing.splittableModel);
	mapEditing.initialiseWidgets({
		stage: mmWidgets('[data-mapjs-role=stage]'),
		domMapController: components.domMapController,
		navigatorShim,
		domImageDimensionCalculator,
		pageState: goldPageState,
		resourceManager: assetUploadController,
		urlDownloader: corsProxyFallbackDownloader
	});
	mapExports.initialiseWidgets();
	measures.initialiseWidgets();
	fileImport.initialiseWidgets();
	historyView.initialiseWidgets();
	goldSessions.initialiseWidgets();

	mmWidgets('mapmenu').menuBarWidget(navigatorShim);
	mmWidgets('[data-mm-node-context]').nodeContextWidget(mapViewing.mapModel);
	mmWidgets('a[download]').downloadLinkWidget(navigatorShim);

	mmWidgets('[data-mm-show-hotkey]').showHotkeyWidget(mmWidgets(document));
	mmWidgets('contextmenu[data-mm-role~="node-context"]').contextMenuWidget(contextMenuModel, mmWidgets('mapeditor'), mmWidgets('body'));
	mmWidgets('contextmenu[data-mm-role~="writer-context"]').contextMenuWidget(new ContextMenuModel(writerModel), mmWidgets('#writer'), mmWidgets('body'), {smallContexts: ['contextMenuRequested']});

	mmWidgets('[data-mm-role=keyboard-color]').keyboardColorWidget(mapViewing.mapModel, mapEditing.mapEditorModel, mapViewing.themeProvider);
	mmWidgets('#searchWidget').searchWidget(mapViewing.mapModel);

	mmWidgets('[data-mm-role~="popup-link"]').popupLinkWidget(navigatorShim);
	mmWidgets('[data-mm-role~=selectable-read-only]').selectableReadOnlyInputWidget();
	mmWidgets('[data-mm-role~=full-screen-view]').fullScreenControlWidget(navigatorShim);
	mmWidgets('tabbedsection').tabbedSectionWidget();
	mmWidgets('[data-mm-sidebar-name]').sidebarWidget(mapEditing.splittableModel);
	mmWidgets('#storyboard').storyboardWidget(storyboardController, storyboardModel, storyboardDimensionProvider, storyboardMapMediator, mapEditing.splittableModel);

	mmWidgets('#writer').writerWidget(writerModel, mapEditing.splittableModel, formatNoteToHtml);

	mmWidgets('[data-mm-install-hotkey]').installHotkeyWidget();
	mmWidgets('[data-mm-context-menu-context]').contextDisablerWidget(contextMenuModel, 'context', 'data-mm-context-menu-context');
	mmWidgets('[data-mm-storyboard-context]').contextDisablerWidget(storyboardController, 'storyboardContext', 'data-mm-storyboard-context');
	mmWidgets('[data-mm-file-save-context]').contextDisablerWidget(unsavedChangesModel, 'fileChangeContext', 'data-mm-file-save-context');
	mmWidgets('[data-mm-file-info-toggle]').fileInfoValueToggleWidget(goldPageController);
	mmWidgets('[data-mm-writer-context]').contextDisablerWidget(writerModel, 'writerContext', 'data-mm-writer-context');
	mmWidgets('[data-mm-themes-context]').contextDisablerWidget(mapViewing.mapThemeModel, 'themesContext', 'data-mm-themes-context');
	mmWidgets('[data-mm-argument-mapping-context]').contextDisablerWidget(mapEditing.argumentMappingModel, 'argumentMappingContext', 'data-mm-argument-mapping-context');
	mmWidgets('[data-mm-map-sharing-context]').contextDisablerWidget(mapSharingModel, 'context', 'data-mm-map-sharing-context');

	mmWidgets('mapeditor').storyboardKeyHandlerWidget(storyboardController, storyboardModel, mapViewing.mapModel, '+');
	mmWidgets('[data-mm-role~=blob-downloader-link]').blobDownloaderLinkWidget(navigatorShim);
	mmWidgets('[data-mm-role~=blob-tab-loader-link]').blobDownloaderLinkWidget(navigatorShim, true);
	mmWidgets('#gold-map-sharing-modal').goldMapSharingWidget(mapSharingModel);
	mmWidgets('[data-mm-role~=file-timestamp]').fileTimestampWidget(goldFileChangesModel);
	mmWidgets('[data-mm-role~="anonymous-files"]').anonymousFilesWidget(storage);
	mmWidgets('[data-mm-role~="file-tags-list"]').fileTagsWidget(goldFileListModel);



	window.components = components;
	clipboard.initialiseWidgets();
	authentication.reauthenticator.reauthenticate().catch(() => true);

	if (editingContext) {
		mmWidgets('body').addClass(editingContext);
	}
};
